import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useLanguage } from '../context/LanguageContext';
import './VerifyEmailPage.css';

export default function VerifyEmailPage() {
  const location = useLocation();
  const email = location.state?.email || '';
  const { t } = useLanguage();

  const [resending, setResending] = useState(false);
  const [resendStatus, setResendStatus] = useState(null);

  const handleResend = async () => {
    if (!email) {
      setResendStatus({ type: 'error', message: t('verifyEmail.noEmailFound') });
      return;
    }

    setResending(true);
    setResendStatus(null);

    try {
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email,
        options: {
          emailRedirectTo: `${window.location.origin}/auth/callback`,
        },
      });

      if (error) {
        setResendStatus({ type: 'error', message: error.message });
      } else {
        setResendStatus({
          type: 'success',
          message: 'Verification email sent! Check your inbox.',
        });
      }
    } catch (err) {
      setResendStatus({ type: 'error', message: 'Failed to resend. Try again.' });
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="verifyEmail">
      <div className="verifyEmail__card">
        <Link to="/" className="verifyEmail__logo">
          <img src="/images/logo-transparent.png" alt="CosmoEstates" />
        </Link>

        <div className="verifyEmail__icon">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
        </div>

        <h1 className="verifyEmail__title">Check your email</h1>

        <p className="verifyEmail__subtitle">We sent a verification link to</p>

        <p className="verifyEmail__email">{email || 'your email'}</p>

        <p className="verifyEmail__instructions">
          Click the link in the email to verify your account and start using CosmoEstates.
          The link expires in 24 hours.
        </p>

        <div className="verifyEmail__divider"></div>

        <p className="verifyEmail__resendText">
          Didn't receive it? Check your spam folder, or
        </p>

        <button
          className="verifyEmail__resendBtn"
          onClick={handleResend}
          disabled={resending}
        >
          {resending ? 'Sending...' : 'Resend verification email'}
        </button>

        {resendStatus && (
          <div className={`verifyEmail__status verifyEmail__status--${resendStatus.type}`}>
            {resendStatus.message}
          </div>
        )}

        <div className="verifyEmail__footer">
          <Link to="/login" className="verifyEmail__link">
            Already verified? Sign in →
          </Link>
        </div>
      </div>
    </div>
  );
}
